"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

// Build a node using a babel-types builder, and emplace it at the given location.
exports.default = function buildAtLoc(loc, builder) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return Object.assign(builder.apply(null, args), loc);
};